// extracted by mini-css-extract-plugin
export var popular = "PopularSection-module--popular--1U4RK";
export var popularCards = "PopularSection-module--popularCards--2w1ag";